import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  blurry: {
    color: 'transparent',
    textShadow: '0 0 5px rgba(0,0,0,0.5)'
  }
}));

const TextPlaceholder = ({ text, className }) => {
  const classes = useStyles();

  return (
    <span data-testid="text-placeholder" className={`${classes.blurry} ${className}`}>
      {text}
    </span>
  );
};

TextPlaceholder.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string
};

TextPlaceholder.defaultProps = {
  text: 'loading...',
  className: ''
};

export default TextPlaceholder;
